import React, { useState, useEffect } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import CardInfoDoctorComponent from "./cardInfoDoctor";
import "./styles.css";
import { disabledDays, onClickDay } from "./controller";

const FourthQuestionComponent = ({
  responseAvailableDates,
  setAppointmentSelected,
  appointmentSelected,
  openModalInfoPatientAndAppointment,
  appointmentSelectedByClickOnCard,
  reasonSelected,
}) => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const currentDate = new Date();

  const monthNames = [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre",
  ];

  const onConFirm = () => {
    if (appointmentSelected) {
      openModalInfoPatientAndAppointment();
    }
  };

  useEffect(() => {
    if (
      responseAvailableDates &&
      responseAvailableDates.availableDates &&
      Object.keys(responseAvailableDates.availableDates).length > 0
    ) {
      const availableDates = responseAvailableDates.availableDates;
      const firstAvailableDate = Object.keys(availableDates).sort()[0];
      const formattedFirstAvailableDate = new Date(firstAvailableDate);
      setSelectedDate(formattedFirstAvailableDate);
      setSelectedAppointment(availableDates[firstAvailableDate]);
    }
  }, [responseAvailableDates]);

  return (
    <div className="containerFourthQuestion">
      <h1 className="questionAppointment">Seleccione una fecha</h1>
      <div className="calendarAndHours">
        <div className="columnCalendar">
          <Calendar
            value={selectedDate}
            tileDisabled={({ date }) =>
              disabledDays({ date }, responseAvailableDates, currentDate)
            }
            onClickDay={(day) =>
              onClickDay(
                day,
                responseAvailableDates,
                setSelectedAppointment,
                setSelectedDate
              )
            }
          />
        </div>
        {selectedAppointment !== null && (
          <div className="columnHours">
            <CardInfoDoctorComponent
              selectedAppointment={selectedAppointment}
              setAppointmentSelected={setAppointmentSelected}
              appointmentSelectedByClickOnCard={
                appointmentSelectedByClickOnCard
              }
            />
          </div>
        )}
      </div>
      <div className="containerInfoAllAppointment">
        <h3 className="reasonInfoAllAppointment">{reasonSelected.title}</h3>
        {appointmentSelected && (
          <>
            <h3 className="reasonInfoAllAppointment">
              {" "}
              con {appointmentSelected.doctor.name}
            </h3>
          </>
        )}
      </div>
      {appointmentSelected && (
        <div className="appointmentDateContainer">
          <h3 className="appointmentDate">
            {appointmentSelected.dayOfWeek}{" "}
            {appointmentSelected.date.split("/")[0]} de{" "}
            {monthNames[Number(appointmentSelected.date.split("/")[1]) - 1]} del{" "}
            {appointmentSelected.date.split("/")[2]}
          </h3>
        </div>
      )}

      {selectedAppointment !== null && (
        <div className="containerBtnConfirmar">
          <button className="btnConfirmarCita" onClick={onConFirm}>
            Confirmar cita
          </button>
        </div>
      )}
    </div>
  );
};

export default FourthQuestionComponent;
